import { useRuntimeConfig } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

/**
 * Composable to retrieve the intercom help center base url with the correct locale and environment.
 *
 * @example
 * To retrieve the faqUrl param
 * ```
 * const { intercomHelpCenterBaseUrl } = useIntercomHelpCenterBaseUrl()
 * ```
 */

interface useIntercomHelpCenterBaseUrlResponse {
  intercomHelpCenterBaseUrl: string
}

export function useIntercomHelpCenterBaseUrl(): useIntercomHelpCenterBaseUrlResponse {
  const { INTERCOM_HELP_CENTER_BASE_URL } = useRuntimeConfig().public

  const currentLocale = useI18nLocale()

  const baseUrl =
    (INTERCOM_HELP_CENTER_BASE_URL as string) || 'https://help.backmarket.com'

  // `new URL` normalizes slashes, so the env var works with or without a
  // trailing `/`. The trailing slash on the path gives `.../de-de/`.
  const { href } = new URL(
    `${currentLocale}/`,
    `${baseUrl.replace(/\/+$/, '')}/`,
  )

  return {
    intercomHelpCenterBaseUrl: href,
  }
}
